import { React, useContext, useState } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import styled, { css  } from 'styled-components';
import { device } from '../../constants/devices';
import { AuthContext } from '../../context';
import Loader from '../../components/Loader';
import ph from '../../imgs/okok.jpg';


const reuseHover = css`
    font-weight: bold;
    color: #fefff8;
`;

const reuseButton = css`
    margin: 10px 10px;
    border-radius: 8px;
    padding: 20px 20px;
    text-align: center;
    color: black;
`;

const Root = styled.div`
    width: 100%;
    min-height: 100vh;
    background-image: url(${ph});
    background-size: 100% 100%;
    padding: 200px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const UserInfoContainer = styled.div`
    width: 30%;
    display: flex;
    justify-content: center;
    background: rgba(255, 255, 255, 0);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.15);
`;

const UserInfoForm = styled.form`
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const InputContainer = styled.section`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`;

const InputLabel = styled.label`
    width: 80px;
    margin: 20px 20px;
`;

const Input = styled.input`
position: absolute
top: 20px
left: 12px
font-size: 16px
color: rgba($dark,.5)
font-weight: 500
transform-origin: 0 0
transform: translate3d(0,0,0)
transition: all 0.2s ease
pointer-events: none


    
    @media ${device.tablet} {
        width: 280px;
    };
`;

const ButtonsContainer = styled.section`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
`;

const LoginButton = styled.button`
    background: #C5D9D9;
    border: none;
    ${reuseButton};

    @media ${device.mobileXS} {
        width: 200px;
    };
    @media ${device.tablet} {
        width: 400px;
    };
    
    &:hover {
        ${reuseHover}
    }
`;

const RegisterButton = styled(Link)`
    background: #a3dea2;
    text-decoration: none;
    ${reuseButton};

    @media ${device.mobileXS} {
        width: 200px;
    };
    @media ${device.tablet} {
        width: 400px;
    };

    &:hover {
        text-decoration: none;
        ${reuseHover}
    }
`;

const ErrorMessage = styled.div`
    text-align: center;
    color: red;
`;

export default function LoginPage() {
    const { setUser } = useContext(AuthContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const history = useHistory();

    const handleInputFocus = () => {
        setErrorMessage('');
    };
    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
    };
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };
    const handleSubmitForm = (e) => {
        e.preventDefault();
        axios.post('http://localhost:3001/login', {
        name: username,
        password: password,
      }).then((response)=>{
        setIsSubmit(true);
        setUser(response.data);
        history.push('/reserve');
        console.log("Succces", response);
      });

        
    }

    return (
        <Root>
            <UserInfoContainer>
                <UserInfoForm onSubmit={handleSubmitForm}>
                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                    <InputContainer>
                        <InputLabel>Username :</InputLabel>
                        <Input value={username} onChange={handleUsernameChange} onFocus={handleInputFocus}  placeholder="Username" />
                    </InputContainer>

                    <InputContainer>
                        <InputLabel>Password : </InputLabel>
                        <Input type="password" value={password} onChange={handlePasswordChange} onFocus={handleInputFocus} placeholder="Password" />
                    </InputContainer>
                    <ButtonsContainer>
                        <LoginButton type="submit">Login</LoginButton>
                        <RegisterButton to='register'>Don't have an account? Register now!</RegisterButton>
                    </ButtonsContainer>
                </UserInfoForm>
            </UserInfoContainer>
            {isSubmit && <Loader isLoad={isSubmit}/>}
        </Root>
    )
}